import React, {Component} from 'react';
import CInput from './CInput'
import CSelect from './CSelect'
import CCheckbox from './CCheckbox'
import CSwitch from './CSwitch'
import CRadio from './CRadio'
import CDatePicker from './CDatePicker'
import CUpload from './CUpload'
import { Form, Tooltip, Button} from 'antd'
import validateAll from "./validate";
import wenhao from '@/assets/images/wenhao.png'
import _ from 'lodash'

class CForm extends Component{

  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onChangeEditHandler = this.onChangeEditHandler.bind(this);
  }

  state = {
    validateStatus: '',
    validate: true,
    info: '',
    value: ''
  }

  validateHandler(value){
    if(!this.props.checkType){
      return true
    }
    let checkTypeArr = this.props.checkType.split('|');
    let validateStatus = null;

    for (let i = 0; i< checkTypeArr.length; i++){
      let checkData = checkTypeArr[i];
      let checkArg = '';
      if(checkData.includes(':')){
        checkArg = checkData.split(':');
        checkData = checkArg[0];
        checkArg = checkArg[1];
      }
      validateStatus = validateAll[checkData](value, checkArg);
      if(!validateStatus.validate){
        break
      }
    }
    this.setState({
      validateStatus: validateStatus.validateStatus,
      validate: validateStatus.validate,
      info: validateStatus.info
    });
    return validateStatus.validate;
  }


  onChange(value){
    this.setState({
      value: value
    });
    this.validateHandler(value);
    this.props.onChange && this.props.onChange(value);
  }

  onSearch(value){
    this.props.onSearch && this.props.onSearch(value);
  }

  onChangeEditHandler(){
    this.props.onChangeEdit && this.props.onChangeEdit();
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value
    })
  }

  componentWillMount(){
    this.setState({
      value: this.props.value
    })
  }

  render(){
    const isInput = ['input', 'number', 'search', 'password', 'textarea'].includes(this.props.type);
    const isSelect = ['select', 'treeSelect'].includes(this.props.type);
    const isCheckbox = ['checkbox'].includes(this.props.type);
    const isCSwitch = ['switch'].includes(this.props.type);
    const isRadio = ['radio'].includes(this.props.type);
    const isDatePicker = ['date', 'mouth', 'range', 'week'].includes(this.props.type);
    const isUpload = ['img'].includes(this.props.type)
    let newExpand = {};
    if(this.props.expand || _.isObject(this.props.expand)){
      newExpand = _.cloneDeep(this.props.expand);
    }
    return (

    <div className='c-form'>
      {this.props.id === 'indicatorid0'?<h3 style={{marginBottom:'20px',marginLeft:'10%'}}>特色加分项1:</h3>:''}
      {this.props.id === 'indicatorid4'?<div className='border'><h3 style={{marginBottom:'20px',marginLeft:'10%'}}>特色加分项2:</h3></div>:''}
      {this.props.id === 'indicatorid8'?<div className='border'><h3 style={{marginBottom:'20px',marginLeft:'10%'}}>特色加分项3:</h3></div>:''}
      {this.props.id === 'indicatorid12'?<div className='border'><h3 style={{marginBottom:'20px',marginLeft:'10%'}}>特色加分项4:</h3></div>:''}
      {this.props.id === 'indicatorid16'?<div className='border'><h3 style={{marginBottom:'20px',marginLeft:'10%'}}>特色加分项5:</h3></div>:''}
      <div className='flex c-form-content'>
        {
          (this.props.linkage === undefined || this.props.linkage === '1') && this.props.label && <div className='c-form-label ellipsis' title={this.props.label}>
            <div className={this.props.type !=='img'?'bg':''}>
              {this.props.checkType.includes('required') && <span className='required-icon'>*</span>}
              {this.props.type !=='img'?this.props.label:''}
              {this.props.showtext?<span style={{color:'red',marginLeft:'10px'}}>({this.props.showtext})</span>:''}
              {this.props.tips !=='' && this.props.type !=='img' ? <Tooltip placement="right" title={this.props.tips}>
                <img src={wenhao} alt="" style={{width:'17px',verticalAlign:'middle',marginLeft:'10px',cursor:'pointer'}}/>
              </Tooltip>: ''}
            </div>
            <div>
              {this.props.newDisabled?'':this.props.showeditbtn?<span className='yl' onClick={this.onChangeEditHandler}>{this.props.ifEdit?'修改':''}</span>:''}
            </div>
          </div>
        }
        <div className='c-form-content-form'>
          <Form>
            <Form.Item className='c-form-item' validateStatus={this.state.validateStatus}>
              {
                isInput &&  <CInput {...newExpand} type={this.props.type} value={this.state.value} placeholder={this.props.placeholder} disabled={this.props.disabled || this.props.ifEdit} onChange={this.onChange} />
              }
              {
                isSelect  &&  <CSelect {...newExpand} muilty={this.props.muilty} type={this.props.type} value={this.state.value} options={this.props.options} placeholder={this.props.placeholder} disabled={this.props.disabled || this.props.ifEdit} onChange={this.onChange} onSearch={this.onSearch} />
              }
              {
                isCheckbox &&  <CCheckbox value={this.state.value} disabled={this.props.disabled || this.props.ifEdit} onChange={this.onChange} options={this.props.options}>{this.props.checkName}</CCheckbox>
              }
              {
                isCSwitch &&  <CSwitch {...newExpand} value={this.state.value} disabled={this.props.disabled || this.props.ifEdit} onChange={this.onChange} />
              }
              {
                isRadio && (this.props.linkage === undefined || this.props.linkage === '1') &&  <CRadio {...newExpand} disabled={this.props.disabled || this.props.ifEdit} value={this.state.value} options={this.props.options} onChange={this.onChange} />
              }
              {
                isDatePicker &&  <CDatePicker {...newExpand} type={this.props.type} disabled={this.props.disabled || this.props.ifEdit} value={this.state.value} onChange={this.onChange} />
              }
              {
                isUpload &&  <CUpload {...newExpand} name={this.props.name} id={this.props.id} btnname={this.props.btnname} specialupload={this.props.specialupload} specialuploadid={this.props.specialuploadid} type={this.props.type} fileList={this.state.value} onChange={this.onChange} disabled={this.props.disabled || this.props.ifEdit} />
              }
            </Form.Item>
          </Form>
        </div>
      </div>
      {this.props.type !== 'img' && (this.props.id !== 'provinceid' && this.props.id !== 'regionid')&& <div className={`c-form-error-info ${!this.props.label ? 'c-form-none-label' : ''}`}>
        {this.state.info}
      </div>}
    </div>
    )
  }
}

export default CForm
